module.exports = __webpack_public_path__ + "img/download.97ec2a0d.svg";